module.exports = __webpack_public_path__ + "static/media/28kostonwelcome.fce1513f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/28kostonwelcome.png
// module id = 123
// module chunks = 0